import { eventType, eventTypeInput, fuelRobDataTypeEnum, fuelTypeEnum, inputDataTypeEnum, tankType } from './enums.js';

export const getFuelRobs = (port, fromDateTimeLocalTime, toDateTimeLocalTime, events, vessel) => {
    const bunkeringCompletedEvents = getBunkeringCompletedEvents(fromDateTimeLocalTime, toDateTimeLocalTime, events);
    const fuelRobDataList = bunkeringCompletedEvents
        .map((o, i) => {
            const bunkeringHoseOnEvents = getBunkeringHoseOnEvents(
                o.eventTypeGroupSequenceIdentity,
                o.concurrentSequenceNumber,
                events
            );

            const fuelType = bunkeringHoseOnEvents
                .flatMap((ev) => {
                    const eventTypeInputReg = ev.eventTypeInputRegList.find(
                        (x) =>
                            x.inputDataTypeId === inputDataTypeEnum.dropdown &&
                            (x.eventTypeInputId === eventTypeInput.bunkerHoseOnGrade ||
                                x.eventTypeInputId === eventTypeInput.bunkerHoseOnAtBerthGrade)
                    );

                    if (eventTypeInputReg) {
                        return eventTypeInputReg.dropdownGroupReg.dropdownItemRegList.map((d) => d.dropdownItemValue);
                    }

                    return [];
                })
                .filter((v, i, a) => a.indexOf(v) === i); // distinct values

            const fuelRobData = getFuelRobData(
                vessel,
                fuelRobDataTypeEnum.measureAfterBunkering,
                o.portId || 0,
                o.eventDate.actualDateTimeLocal,
                i
            );

            fuelRobData.fuelRobPerTanks = fuelRobData.fuelRobPerTanks.filter((x) =>
                fuelType.includes(getFuelTypeFromEnum(x.fuelType))
            );

            return fuelRobData;
        })
        .filter((x) => x.fuelRobPerTanks.length > 0);

    if (toDateTimeLocalTime.getHours() === 12 && toDateTimeLocalTime.getMinutes() === 0) {
        fuelRobDataList.push(
            getFuelRobData(
                vessel,
                fuelRobDataTypeEnum.estimationAtNoon,
                port?.portId || 0,
                '9999-12-31T23:59:59.9999999',
                0
            )
        );
    }

    return fuelRobDataList;
};

const getBunkeringHoseOnEvents = (eventTypeGroupSequenceIdentity, concurrentSequenceNumber, events) => {
    return events.filter(
        (o) =>
            (o.eventTypeId === eventType.bunkerHoseOn || o.eventTypeId === eventType.bunkerHoseOnAtBerth) &&
            o.eventTypeGroupSequenceIdentity === eventTypeGroupSequenceIdentity &&
            o.concurrentSequenceNumber === concurrentSequenceNumber
    );
};

const getBunkeringCompletedEvents = (startTimeLocalTime, stopTimeLocalTime, events) => {
    return events.filter(
        (o) =>
            (o.eventTypeId === eventType.bunkeringCompleted || o.eventTypeId === eventType.bunkeringCompletedAtBerth) &&
            o.eventDate.actualDateTimeLocal > startTimeLocalTime &&
            o.eventDate.actualDateTimeLocal <= stopTimeLocalTime
    );
};

const getFuelRobData = (vessel, fuelRobDataType, portId, robDateTime, indexInDay) => {
    const fuelRobData = {
        type: fuelRobDataType,
        fuelRobPerTanks: null,
        portId,
        dateUtc: robDateTime,
        hfoCorrectionInMt: null,
        mgoCorrectionInMt: null,
        indexInDay,
        eventDateTime: robDateTime,
    };

    const fuelRobPerTanks = [];
    const tankList = getNonCargoTanks(vessel)
        .filter(
            (tank) =>
                tank.tankType === tankType.dieselOil ||
                tank.tankType === tankType.heavyFuelOil ||
                tank.tankType === tankType.virtualHfo ||
                tank.tankType === tankType.virtualMgo
        )
        .sort((a, b) => a.tankName.localeCompare(b.tankName));

    tankList.forEach((tank) => {
        fuelRobPerTanks.push({
            tankId: tank.tankId,
            volume: 0,
            temperature: 0,
            ullage: 0,
            sounding: 0,
            correctionFactor: 0.95,
            remarks: null,
            fuelType: getFuelType(tank),
        });
    });

    fuelRobData.fuelRobPerTanks = fuelRobPerTanks;
    return fuelRobData;
};

const getNonCargoTanks = (vessel) => {
    return vessel.tanks
        ? vessel.tanks
              .filter((tank) => tank.tankType && tank.tankType !== tankType.cargo)
              .sort((a, b) => a.tankId - b.tankId)
        : [];
};

const getFuelType = (tank) =>
    tank.tankType === tankType.dieselOil || tank.tankType === tankType.virtualMgo ? fuelTypeEnum.mgo : fuelTypeEnum.hfo;

const getFuelTypeFromEnum = (fuelType) => {
    if (fuelType === fuelRobDataTypeEnum.mgo) return 'MGO';
    if (fuelType === fuelRobDataTypeEnum.hfo) return 'HFO';
    return '';
};
